import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@sproutsocial/racine';
import './index.css';
import Connector from './connector/Connector';
import App from './App';
var tableau = window.tableau;
var connector = new Connector("Sprout Social", tableau, window.fetch.bind(window));
ReactDOM.render(_jsx(React.StrictMode, { children: _jsx(ThemeProvider, { children: _jsx(App, { connector: connector }) }) }), document.getElementById('root'));
